<template>
    <v-dialog v-model="dialog" scrollable width="1000px">
        <v-card flat class="px-2">
            <v-card-title class="justify-center"><h3>Email preview</h3></v-card-title>
            <v-divider/>       
            <v-card-text class="ma-0 px-4">
                <v-row no-gutters>
                    <v-col cols="2">From</v-col>
                    <v-col cols="10">{{ maildata.gebr_email }}</v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2">To</v-col>
                    <v-col cols="10">{{ maildata.pten_email }}</v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2">Subject</v-col>
                    <v-col cols="10">{{ mailtext.subject }}</v-col>
                </v-row>
                <!-- <v-row no-gutters v-for="(attachment, index) in attachments" :key="attachment.attm_nr">
                    <v-col cols="2"><div v-if="index===0">Attachments</div></v-col>
                    <v-col cols="10">{{ attachment.description }}.{{ attachment.extension }}</v-col>
                </v-row> -->
                <v-row no-gutters class="pb-4">
                    <v-col cols="2">Attachments</v-col>
                    <v-col cols="9">
                        <span v-for="(attachment, index) in attachments" :key="attachment.attm_nr"><span v-if="index>0">, </span>"{{ attachment.description }}.{{ attachment.extension }}"</span>
                    </v-col>
                </v-row>                
            </v-card-text>
            <v-divider/>
            <v-card-text scrollable>  
                <v-row no-gutters>
                    <v-col cols="12">
                        <div v-html="preview" id="preview"></div>
                    </v-col>
                </v-row>
            </v-card-text>  
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary ml-4" small v-on:click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {    
        components: {
        },
        props: {
        },
        data () {
            return {
                dialog: false,
                preview: "",
                attachments: [],
                mailtext: {},
                maildata: {},   
            }
        },          
        methods: {
            openDialog(maildata, mailtext, attachments, preview) {
                this.maildata = maildata;
                this.mailtext = mailtext;
                this.attachments = attachments;
                this.preview = preview
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
        },
    }
</script>

<style scoped>
    /* .scrollable {
        max-height: 500px;
        overflow-x: hidden;
        overflow-y: auto;
    } */
</style>